import { SET_LOGOUT, CLEAR_ALL } from '../../../store/Types';

export const GETALL_DOCENTES = 'GETALL_DOCENTES';
export const LOADING_GETALL_DOCENTES = 'LOADING_GETALL_DOCENTES';
export const ACTIVO_DOCENTES = 'ACTIVO_DOCENTES';
export const PARAMS_DOCENTES = 'PARAMS_DOCENTES';

const initialState = {
  all: [],
  loadingGetAll: false,
  meta: null,
  links: null,
  activo: null,
  params: {},
};

export const docentesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_DOCENTES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_GETALL_DOCENTES:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case ACTIVO_DOCENTES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_DOCENTES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
